import { render, staticRenderFns } from "./jobhunting1.vue?vue&type=template&id=1dda650c&scoped=true"
import script from "./jobhunting1.vue?vue&type=script&lang=js"
export * from "./jobhunting1.vue?vue&type=script&lang=js"
import style0 from "./jobhunting1.vue?vue&type=style&index=0&id=1dda650c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda650c",
  null
  
)

export default component.exports